import React from 'react';
import { H4 } from 'components/typography';
import { AddAttachment } from 'components';
import { useTranslation } from 'react-i18next';
import {
  AttachmentDocumentContentTypeEnum,
  AttachmentImageContentTypeEnum,
  AttachmentVariantEnum,
} from 'lane-shared/types/attachment';
import { ContentTypeEnum } from 'constants-content';
import { AmazonS3Buckets } from 'lane-shared/config';
import styles from '../Details.scss';

interface ServiceRequestAttachmentsProps {
  attachmentRefId: string;
  hasAttachFilesPermission: boolean;
  isStaffUser: boolean;
  className?: string;
}

export function ServiceRequestAttachments({
  attachmentRefId,
  hasAttachFilesPermission,
  isStaffUser,
  className,
}: ServiceRequestAttachmentsProps) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <H4 mb={2}>{t('web.admin.serviceRequest.attachment.heading')}</H4>
      {hasAttachFilesPermission && (
        <span className={styles.ServiceRequestAttachmentsDisclaimer}>
          {t('web.admin.serviceRequest.attachment.disclaimer')}
        </span>
      )}
      <AddAttachment
        entityId={attachmentRefId}
        entityType={ContentTypeEnum.WorkOrder}
        editMode={false}
        variant={AttachmentVariantEnum.WorkOrder}
        preventDelete={isStaffUser}
        canAddAttachments={hasAttachFilesPermission}
        acceptedFileTypes={[
          ...Object.values(AttachmentImageContentTypeEnum),
          AttachmentDocumentContentTypeEnum.pdf,
        ]}
        s3Bucket={AmazonS3Buckets.Activate}
      />
    </div>
  );
}
